import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import {AmorgRoutes} from './AmorgRoutes';
import { GlobalStyle } from './globalStyles';
import { StyleSheetManager } from 'styled-components';
import isPropValid from '@emotion/is-prop-valid';


// Modal.setAppElement('#root');

export const redirectOnError = false;
export const redirectOnInsufficientPermission = true;

const container = document.getElementById("root");

if (container) {
	const root = createRoot(container);
	root.render(
		<StyleSheetManager
			enableVendorPrefixes
			shouldForwardProp={(propName, target) => typeof target !== 'string' || isPropValid(propName)}
		>
			<GlobalStyle />
			<BrowserRouter>
				<AmorgRoutes />
			</BrowserRouter>
		</StyleSheetManager>
	);
}